export default __webpack_public_path__ + "static/media/birthday-blue.49689e93.svg";